export const STATUS={
  STANDBY: 'STANDBY',
  ONGOING: 'ONGOING',
  COMPLETED: 'COMPLETED'
}